/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_ConfiguredInputs */

const es_billing_alerts_configured = /** @type {(inputs: Billing_Alerts_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas configuradas`)
};

const en_billing_alerts_configured = /** @type {(inputs: Billing_Alerts_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configured alerts`)
};

/**
* | output |
* | --- |
* | "Configured alerts" |
*
* @param {Billing_Alerts_ConfiguredInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_configured = /** @type {((inputs?: Billing_Alerts_ConfiguredInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_ConfiguredInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_configured(inputs)
	return en_billing_alerts_configured(inputs)
});
export { billing_alerts_configured as "billing.alerts.configured" }